<div class="row wrapper border-bottom white-bg page-heading">
  <div class="row">
    <div class="col-lg-12">
        <div class="card product-detail bg-emphasis bg-opacity-30">
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">

                <img class="logo" src="/assets/images/cerestag.png"/>

              </div>
              <div class="col-md-5">

                <div *ngIf="application && application.applicationConfiguration">
                  <div>
                    <dl class="row mb-0">
                      <div class="col-sm-4 text-sm-right">
                          <dt>Client ID:</dt>
                      </div>
                      <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">{{application.applicationConfiguration.clientId}}</dd>
                      </div>
                    </dl>
                    <dl class="row mb-0">
                      <div class="col-sm-4 text-sm-right">
                          <dt>Farm ID:</dt>
                      </div>
                      <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">{{farm.displayName}}</dd>
                      </div>
                    </dl>
                    <dl class="row mb-0">
                      <div class="col-sm-4 text-sm-right">
                          <dt>Data Source:</dt>
                      </div>
                      <div class="col-sm-8 text-sm-left">
                          <dd class="mb-1">TEST DATA SET</dd>
                      </div>
                    </dl>
                  </div>
                </div>

              </div>
              <div class="col-md-5">

                <div *ngIf="application && application.applicationConfiguration">
                  <div>
                   
                    <dl class="row mb-0">
                        <div class="col-sm-4 text-sm-right">
                            <dt>Farms:</dt>
                        </div>
                        <div class="col-sm-8 text-sm-left">
                            <dd class="mb-1">{{application.applicationConfiguration.farms.length}}</dd>
                        </div>
                    </dl>
                    <dl class="row mb-0">
                      <div class="col-sm-4 text-sm-right">
                          <dt>Status:</dt>
                      </div>
                      <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">
                          <span *ngIf="application.applicationConfiguration.connected" class="label label-success">Active</span>
                          <span *ngIf="!application.applicationConfiguration.connected" class="label label-danger">Pending</span>
                        </dd>
                      </div>
                    </dl>
                    <dl class="row mb-0" >
                      <div class="col-sm-4 text-sm-right">
                          <dt>Tag Count:</dt>
                      </div>
                      <div class="col-sm-8 text-sm-left">
                        <dd class="mb-1">
                          {{tagCount}}
                        </dd>
                      </div>
                    </dl>
                  </div>
                </div>

              </div>                
            </div>
            <div class="row">
              
            </div>
          </div>
          
          <!-- card-arrow -->
          <div class="card-arrow">
            <div class="card-arrow-top-left"></div>
            <div class="card-arrow-top-right"></div>
            <div class="card-arrow-bottom-left"></div>
            <div class="card-arrow-bottom-right"></div>
          </div>
        </div>
    </div>
  </div>  

  <div class="row mt-4" *ngIf="config">
    <div class="col-lg-12">

      <div class="card product-detail">
        <div class="card-body bg-emphasis bg-opacity-15">
          <div class="row" *ngIf="config">
            <div class="col-lg-4">

              <div class="fw-bold mb-3 fs-16px">Reports</div>

              <!--<div class="d-flex align-items-center mb-3">
                <img src="assets/img/cow.jpg" alt="" width="30" class="rounded-circle">
                <div class="flex-fill px-3">
                  <div class="fw-bold text-truncate w-150px">Latest Locations</div>
                  <div class="fs-12px text text-opacity-50">Where is my herd?</div>
                </div>
                <a (click)="selectReport('latest')" class="btn btn-sm btn-outline-theme fs-11px" [class.disabled]="selectedReport=='latest' ? 'disabled' : null">Select</a>
              </div>-->

              <div class="d-flex align-items-center mb-3">
                <img src="assets/img/heat.jpg" alt="" width="30" class="rounded-circle">
                <div class="flex-fill px-3">
                  <div class="fw-bold text-truncate w-150px">Activity</div>
                  <div class="fs-12px text-opacity-80 text-opacity-50">Last 24 Hours</div>
                </div>
                <a (click)="selectReport('last1')" class="btn btn-sm btn-outline-theme fs-11px" [class.disabled]="selectedReport=='last1' ? 'disabled' : null">Select</a>
              </div>

              <div class="d-flex align-items-center mb-3">
                <img src="assets/img/heat.jpg" alt="" width="30" class="rounded-circle">
                <div class="flex-fill px-3">
                  <div class="fw-bold text-truncate w-150px">Activity</div>
                  <div class="fs-12px text text-opacity-50">Last 7 Days</div>
                </div>
                <a (click)="selectReport('last7')" class="btn btn-sm btn-outline-theme fs-11px" [class.disabled]="selectedReport=='last7' ? 'disabled' : null">Select</a>
              </div>

              <div class="d-flex align-items-center mb-3">
                <img src="assets/img/heat.jpg" alt="" width="30" class="rounded-circle">
                <div class="flex-fill px-3">
                  <div class="fw-bold text-truncate w-150px">Activity</div>
                  <div class="fs-12px text text-opacity-50">Last 30 Days</div>
                </div>
                <a (click)="selectReport('last30')" class="btn btn-sm btn-outline-theme fs-11px" [class.disabled]="selectedReport=='last30' ? 'disabled' : null">Select</a>
              </div>

              <hr class="mt-4 mb-4">

              <div class="fw-bold mb-3 fs-16px">Tasks</div>

              <!--<div class="d-flex align-items-center mb-3">
                <img src="assets/img/cow.jpg" alt="" width="30" class="rounded-circle">
                <div class="flex-fill px-3">
                  <div class="fw-bold text-truncate w-150px">Setup Dashboard</div>
                  <div class="fs-12px text text-opacity-50">Setup standard dashboard</div>
                </div>
                <a disabled="true" class="btn btn-sm btn-outline-theme fs-11px" [class.disabled]="true" title="Coming Soon">Create</a>
              </div>-->

              <div class="d-flex align-items-center mb-3">
                <img src="assets/img/cow.jpg" alt="" width="30" class="rounded-circle">
                <div class="flex-fill px-3">
                  <div class="fw-bold text-truncate w-250px">Activity Alarms <span class="badge badge-primary" style="color:yellow">Coming Soon!</span></div>
                  <div class="fs-12px text text-opacity-50">Alarm on Activity Levels</div>
                </div>
                <a disabled="true" class="btn btn-sm btn-outline-theme fs-11px" [class.disabled]="true" title="Coming Soon">Edit</a>
              </div>

              <div class="d-flex align-items-center mb-3">
                <img src="assets/img/cow.jpg" alt="" width="30" class="rounded-circle">
                <div class="flex-fill px-3">
                  <div class="fw-bold text-truncate w-250px">Geo Fence Alarms <span class="badge badge-primary" style="color:yellow">Coming Soon!</span></div>
                  <div class="fs-12px text text-opacity-50">Alarm on leaving/entering geo fence areas</div>
                </div>
                <a disabled="true" class="btn btn-sm btn-outline-theme fs-11px" [class.disabled]="true" title="Coming Soon">Edit</a>
              </div>

              <div class="d-flex align-items-center mb-3">
                <img src="assets/img/cow.jpg" alt="" width="30" class="rounded-circle">
                <div class="flex-fill px-3">
                  <div class="fw-bold text-truncate w-250px">Build My Farm<!-- <span class="badge badge-primary" style="color:red">New!</span>--></div>
                  <div class="fs-12px text text-opacity-50">Map out important boundaries and fixtures</div>
                </div>
                <a *ngIf="!drawing" (click)="startDrawing()" class="btn btn-sm btn-outline-theme fs-11px">Draw</a>
                <a *ngIf="drawing" (click)="cancelDrawing()" class="btn btn-sm btn-outline-danger fs-11px">Cancel</a>
                <a *ngIf="drawing" (click)="finishDrawing()" class="btn btn-sm btn-outline-theme fs-11px">Save</a>
              </div>

            </div>
            <div class="col-lg-8">
                  
              <open-street-map #streetMap [style]="'height:500px'" [mapheight]="'500px'" [shapes]="farm.geoJsonObjects" [mapType]="'googleSat'"></open-street-map>

              <br/>
              Tag Activity
              <highcharts-chart
                    [Highcharts]="Highcharts"
                    [constructorType]="chartConstructor"
                    [options]="chartOptions"
                    [callbackFunction]="activityChartCallback"
                    style="width: 100%; display: block">
              </highcharts-chart>

              <br/>
              Tag Temperature (Degrees C)
              <highcharts-chart
                    [Highcharts]="Highcharts"
                    [constructorType]="chartConstructor"
                    [options]="chartOptions"
                    [callbackFunction]="temperatureChartCallback"
                    style="width: 100%; display: block">
              </highcharts-chart>
            </div>
          </div>  
        </div>
        <!-- card-arrow -->
        <div class="card-arrow">
          <div class="card-arrow-top-left"></div>
          <div class="card-arrow-top-right"></div>
          <div class="card-arrow-bottom-left"></div>
          <div class="card-arrow-bottom-right"></div>
        </div>
      </div> 
      
    </div>
  </div>
</div>
